// import {
//   Box,
//   TextField,
//   Grid,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Typography,
//   MenuItem
// } from "@mui/material";


const PaymentInfoForm = ({ formData, handleChange }) => {
   return (
      <div className="space-y-6">
         <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-100 pb-2">
            บัญชีธนาคารสำหรับโอนเงิน
         </h3>

         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1">
               <label className="text-sm font-medium text-gray-700">ชื่อบัญชี</label>
               <input
                  type="text"
                  value={formData.bankAccountName || ""}
                  onChange={handleChange("bankAccountName")}
                  className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
               />
            </div>
            <div className="space-y-1">
               <label className="text-sm font-medium text-gray-700">ธนาคาร</label>
               <select
                  value={formData.bankName || ""}
                  onChange={handleChange("bankName")}
                  className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all appearance-none"
               >
                  <option value="">เลือกธนาคาร...</option>
                  {[
                     "กรุงเทพ",
                     "กสิกรไทย",
                     "กรุงไทย",
                     "กรุงศรีอยุธยา",
                     "ไทยพาณิชย์",
                     "ทหารไทยธนชาต",
                     "ยูโอบี",
                     "ซีไอเอ็มบีไทย",
                     "เกียรตินาคินภัทร",
                     "ออมสิน",
                     "ธ.ก.ส.",
                  ].map((bank) => (
                     <option key={bank} value={bank}>{bank}</option>
                  ))}
               </select>
            </div>
            <div className="space-y-1">
               <label className="text-sm font-medium text-gray-700">เลขที่บัญชี</label>
               <input
                  type="text"
                  value={formData.bankAccountNumber || ""}
                  onChange={handleChange("bankAccountNumber")}
                  className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
               />
            </div>
            <div className="space-y-1">
               <label className="text-sm font-medium text-gray-700">สาขา</label>
               <input
                  type="text"
                  value={formData.bankBranch || ""}
                  onChange={handleChange("bankBranch")}
                  className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all"
               />
            </div>
         </div>

         <hr className="border-gray-100" />

         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Purchase Tax */}
            <div className="space-y-3">
               <label className="text-sm font-semibold text-gray-800 block">การคำนวณภาษีซื้อ</label>
               <div className="space-y-2">
                  {[
                     { val: "default", label: "ใช้ค่าเริ่มต้น (ไม่คำนวณภาษีมูลค่าเพิ่ม)" },
                     { val: "noVat", label: "ไม่คำนวณภาษีมูลค่าเพิ่ม" },
                     { val: "vatIncluded", label: "ยอดรวมภาษีมูลค่าเพิ่มแล้ว" },
                     { val: "vatExcluded", label: "ยอดยังไม่รวมภาษีมูลค่าเพิ่ม" }
                  ].map((opt) => (
                     <label key={opt.val} className="flex items-center space-x-3 cursor-pointer p-2 rounded-lg hover:bg-gray-50 transition-colors">
                        <input
                           type="radio"
                           name="purchaseTaxOption"
                           value={opt.val}
                           checked={formData.purchaseTaxOption === opt.val}
                           onChange={handleChange("purchaseTaxOption")}
                           className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                        />
                        <span className="text-sm text-gray-700">{opt.label}</span>
                     </label>
                  ))}
               </div>
            </div>

            {/* Sales Tax */}
            <div className="space-y-3">
               <label className="text-sm font-semibold text-gray-800 block">การคำนวณภาษีขาย</label>
               <div className="space-y-2">
                  {[
                     { val: "default", label: "ใช้ค่าเริ่มต้น (ไม่คำนวณภาษีมูลค่าเพิ่ม)" },
                     { val: "noVat", label: "ไม่คำนวณภาษีมูลค่าเพิ่ม" },
                     { val: "vatIncluded", label: "ยอดรวมภาษีมูลค่าเพิ่มแล้ว" },
                     { val: "vatExcluded", label: "ยอดยังไม่รวมภาษีมูลค่าเพิ่ม" }
                  ].map((opt) => (
                     <label key={opt.val} className="flex items-center space-x-3 cursor-pointer p-2 rounded-lg hover:bg-gray-50 transition-colors">
                        <input
                           type="radio"
                           name="salesTaxOption"
                           value={opt.val}
                           checked={formData.salesTaxOption === opt.val}
                           onChange={handleChange("salesTaxOption")}
                           className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                        />
                        <span className="text-sm text-gray-700">{opt.label}</span>
                     </label>
                  ))}
               </div>
            </div>
         </div>

         <hr className="border-gray-100" />

         {/* Rounding Option */}
         {/* <div className="space-y-3">
         <label className="text-sm font-semibold text-gray-800 block">การปัดเศษจำนวน</label>
         <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {[
              { val: "none", label: "ไม่ปัดเศษ", sub: "" },
              { val: "alwaysRound", label: "ปัดเศษเสมอ", sub: "" },
              { val: "never", label: "ปัดขึ้นเสมอ", sub: "เช่น 1.01 ปัดขึ้นเป็น 2.00, 1.56 ปัดขึ้นเป็น 2.00" },
              { val: "whenGreaterOrEqual50", label: "ปัดขึ้นเป็น 1 เมื่อตัวเลข >= 0.50 เท่านั้น", sub: "เช่น 1.56 ปัดขึ้นเป็น 2.00, 1.49 ปัดลงเป็น 1.00" },
              { val: "between00and50", label: "ปัดขั้น 0.50 เมื่อตัวเลข > 0.00 หรือ > 0.50", sub: "เช่น 1.01 ปัดขึ้นเป็น 1.50, 1.78 ปัดขึ้นเป็น 2.00" },
              { val: "between025and075", label: "ปัดขึ้น 0.50 เมื่อตัวเลข ≥ 0.25 หรือ ≥ 0.75", sub: "เช่น 1.26 ปัดขึ้นเป็น 1.50, 1.78 ปัดขึ้นเป็น 2.00" },
              { val: "alwaysClose", label: "ปัดลงเสมอ", sub: "เช่น 1.56 ปัดลงเป็น 1.00, 1.01 ปัดลงเป็น 1.00" },
              { val: "lessThan100or050", label: "ปัดลง 0.50 เมื่อตัวเลข < 1.00 หรือ < 0.50", sub: "เช่น 1.56 ปิดลงเป็น 1.50, 1.45 ปัดลงเป็น 1.00" },
            ].map((opt) => (
                <label key={opt.val} className="flex items-start space-x-3 cursor-pointer p-3 rounded-lg border border-transparent hover:bg-gray-50 hover:border-gray-200 transition-all">
                   <div className="pt-0.5">
                      <input
                         type="radio"
                         name="roundingOption"
                         value={opt.val}
                         checked={formData.roundingOption === opt.val}
                         onChange={handleChange("roundingOption")}
                         className="w-4 h-4 text-green-600 focus:ring-green-500 border-gray-300"
                      />
                   </div>
                   <div>
                       <span className="text-sm font-medium text-gray-900 block">{opt.label}</span>
                       {opt.sub && <span className="text-xs text-gray-500 block mt-0.5">{opt.sub}</span>}
                   </div>
                </label>
            ))}
         </div>
      </div> */}

      </div>
   );
};

export default PaymentInfoForm;
